/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["li:hover .hover-underline{text-decoration:underline;-webkit-text-decoration-color:#4fc2c0!important;text-decoration-color:#4fc2c0!important;text-decoration-thickness:1.5px;color:#4fc2c0!important}#live-chat,#support-tel,#support-tel-icon{color:#000!important}li:hover #live-chat,li:hover #support-tel,li:hover #support-tel-icon{color:#4fc2c0!important}\n/*# sourceMappingURL=topbar.component.css.map*/"];
export { styles as styles };
